import Swal from 'sweetalert2';

let sessionTimeout;
let sessionExpiryAlertTimeout;
let isAlertShown = false;
let isLoggedOut = false;
let lastActivityTime = Date.now();

const SESSION_DURATION = 15 * 60 * 1000; // 15 min (fixed)
const ALERT_BEFORE = 5 * 60 * 1000; // 5 min before

// ✅ Set data with FIXED expiry (only here)
function setLocalStorageData(userData) {
  const expiryTime = Date.now() + SESSION_DURATION;

  const data = {
    ...userData,
    expiryTime
  };

  localStorage.setItem('userData', JSON.stringify(data));
  resetSessionTimeout();
}

// ✅ Get data
function getLocalStorageData() {
  const storedData = localStorage.getItem('userData');
  if (!storedData) return null;

  const parsedData = JSON.parse(storedData);

  if (Date.now() > parsedData.expiryTime) {
    showSessionExpiredAlert();
    return null;
  }

  return parsedData;
}

// ✅ Remove data
function removeLocalStorageData() {
  localStorage.removeItem('userData');
}

// ✅ Redirect
function redirectToLogin() {
  // if (!isLoggedOut) {
  //   isLoggedOut = true;
    window.location.href = '/login';
  // }
}

function showSessionExpiryAlert() {
  if (isLoggedOut || isAlertShown) return;

  isAlertShown = true;

  Swal.fire({
    icon: 'warning',
    title: 'Session Expiring Soon',
    text: 'Your session will expire in 5 minutes due to inactivity.',
    showCancelButton: true,
    confirmButtonText: 'Stay Logged In',
    cancelButtonText: 'Logout Now',
    timer: undefined,
    allowOutsideClick: false,
    allowEscapeKey: false
  }).then((result) => {
    isAlertShown = false;

    if (result.isConfirmed) {
      resetSessionTimeout();
    } else {
      showSessionExpiredAlert();
    }
  });
}
// 🔴 Expired Alert (instant redirect fix included)
function showSessionExpiredAlert() {
  if (!isLoggedOut) {
    isLoggedOut = true;

    removeLocalStorageData();

    Swal.fire({
      icon: 'warning',
      title: 'Session Expired!',
      text: 'Your session has expired. Please login again.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Login Again'
    }).then(() => {
      redirectToLogin(); // ✅ instant redirect on OK
    });

    // 🔥 fallback safety (important)
    setTimeout(() => {
      redirectToLogin();
    }, 1000);
  }
}

// 🔥 Central Expiry Checker
function checkSessionExpiry() {
  const storedData = localStorage.getItem('userData');
  if (!storedData) return;

  const parsedData = JSON.parse(storedData);

  if (Date.now() > parsedData.expiryTime) {
    showSessionExpiredAlert();
  }
}

// 🔁 Reset timer ONLY (NO expiry extend)
function resetSessionTimeout() {
  clearTimeout(sessionTimeout);
  clearTimeout(sessionExpiryAlertTimeout);

  const storedData = localStorage.getItem('userData');
  if (!storedData) return;

  const parsedData = JSON.parse(storedData);

  const remainingTime = parsedData.expiryTime - Date.now();

  if (remainingTime <= 0) {
    showSessionExpiredAlert();
    return;
  }

  isAlertShown = false;

  // ⚠️ Alert before expiry
  if (remainingTime > ALERT_BEFORE) {
    sessionExpiryAlertTimeout = setTimeout(() => {
      showSessionExpiryAlert();
    }, remainingTime - ALERT_BEFORE);
  }

  // 🔴 Logout exactly at expiry
  sessionTimeout = setTimeout(() => {
    showSessionExpiredAlert();
  }, remainingTime);
}

// ✅ Activity handler (NO expiry extend)
function resetSessionTimeoutThrottled() {
  const now = Date.now();

  // 🔥 ALWAYS check expiry first
  checkSessionExpiry();

  if (now - lastActivityTime > 10000) {
    lastActivityTime = now;
    resetSessionTimeout();
  }
}

// 🎯 Setup listeners
function setupSessionTimeoutListener() {
  const events = ['mousemove', 'keydown', 'click'];

  events.forEach(event => {
    document.addEventListener(event, resetSessionTimeoutThrottled);
  });

  // 🔥 Tab change
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      checkSessionExpiry();
    }
  });

  // 🔥 Window focus
  window.addEventListener('focus', () => {
    checkSessionExpiry();
  });

  // 🔥 Page resume (sleep fix)
  window.addEventListener('pageshow', () => {
    checkSessionExpiry();
  });

  // 🔥 Background check
  setInterval(() => {
    checkSessionExpiry();
  }, 30000);
}

// ✅ On load
function checkSessionOnLoad() {
  const storedData = localStorage.getItem('userData');

  if (!storedData) return;

  const parsedData = JSON.parse(storedData);

  if (Date.now() > parsedData.expiryTime) {
    showSessionExpiredAlert();
  } else {
    resetSessionTimeout();
  }
}

// ✅ Manual logout
function setLoggedOutStatus(status) {
  isLoggedOut = status;
}

export {
  setLocalStorageData,
  getLocalStorageData,
  removeLocalStorageData,
  setupSessionTimeoutListener,
  resetSessionTimeout,
  setLoggedOutStatus,
  checkSessionOnLoad
};